// @see TS version: assets/scripts/enums/officeType.ts
export const OfficeTypeEnum = {
  OPEN_SPACE: 'open_space',
  PRIVATE: 'private',
  INDEPENDENT: 'independent',
};
